import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import {Module} from 'vuex'
import {RootState} from '@/store/types'
import mutations from '@/modules/cms/modules/gallery/store/mutations'
import actions from '@/modules/cms/modules/gallery/store/actions';
import GalleryItem from '@/modules/cms/modules/gallery/model/GalleryItem';

export interface GalleryState {
    /**
     * Lista de galerías cargadas en la aplicación
     */
    galleryList: Gallery[]

    /**
     * Galería actualmente en edición por el usuario
     */
    currentGallery: Gallery

    /**
     * Elemento de una galería actualmente en edición por el usuario
     */
    currentGalleryItem: GalleryItem

    /**
     * Indica si la aplicación ya ha obtenido la lista de galerías
     */
    galleryListFetched: boolean,
}

/**
 * Modulo de Vuex
 */
const module: Module<GalleryState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state: {
        galleryList: [],
        currentGallery: new Gallery(),
        currentGalleryItem: new GalleryItem(),
        galleryListFetched: false,
    },
}

export default module


